/**
 * HL7 v3-ActCode encounter classes — the FHIR R4 `Encounter.class` value set.
 * Trimmed to the codes commonly used in ambulatory + telehealth + acute workflows.
 */
export const ENCOUNTER_CLASS_SYSTEM = 'http://terminology.hl7.org/CodeSystem/v3-ActCode';

export interface EncounterClassCode {
  system: string;
  code: string;
  display: string;
}

export const AMBULATORY_CLASS = {
  system: ENCOUNTER_CLASS_SYSTEM,
  code: 'AMB',
  display: 'Ambulatory',
} as const satisfies EncounterClassCode;

export const VIRTUAL_CLASS = {
  system: ENCOUNTER_CLASS_SYSTEM,
  code: 'VR',
  display: 'Virtual',
} as const satisfies EncounterClassCode;

export const ENCOUNTER_CLASSES = [AMBULATORY_CLASS, VIRTUAL_CLASS] as const satisfies readonly EncounterClassCode[];
